import { Tool } from '../types';

export const featuredTools: Tool[] = [
  {
    title: "Digital Brain Creator",
    description: "Define and refine your business with AI-powered coaching.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414931/digital-brain_xqnnuw.jpg",
    url: "https://chatgpt.com/g/g-qpOHuNFjx-your-digital-brain-creator",
    rating: 0,
    reviews: 0,
    categories: ["Foundational", "Marketing Strategy"],
    tags: ["digital brain", "coaching", "business strategy", "foundational"],
    isHidden: false
  },
    {
    title: "Big Idea Signature Framework",
    description: "Create A Unique Signature Framework for your business offers that captivate and convert.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1741906958/Big-idea-signature-framework_rnd10y.png",
    url: "https://chatgpt.com/g/g-J9dkcb6LH-big-idea-signature-framework-v5",
    rating: 0,
    reviews: 0,
    categories: ["Offer Creation", "Marketing Campaigns", "Foundational", "Branding"],
    tags: ["signature framework", "offer creation", "marketing campaigns", "branding"],
    isHidden: false
  },
    {
    title: "Trinity Of Transformation - Value Ladder",
    description: "Design and plan product offerings with strategic alignment.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1741907588/a-night-scene-of-a-cyberpunk-city-with-t_v3FTObl4TP-gxPBBcx4Gdw_cP-XgOjNQCGpjIZOSlvNDQ_ztx6mk.png",
    url: "https://chatgpt.com/g/g-wN2wM1K4k-value-ladder-strategist",
    rating: 0,
    reviews: 0,
    categories: ["Marketing Strategy", "Offer Creation", "Foundational"],
    tags: ["value ladder", "product offerings", "marketing strategy", "offer creation"],
    isHidden: false
  },
    {
    title: "Funnel System Planner",
    description: "Design effective sales funnels for maximum conversion.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414935/funnel-system-planner_jnzwqi.jpg",
    url: "https://chatgpt.com/g/g-7ySsZs40Y-funnel-system-planner",
    rating: 0,
    reviews: 0,
    categories: ["Marketing Strategy", "Marketing Campaigns", "Foundational"],
    tags: ["sales funnel", "conversion", "marketing strategy", "marketing campaigns"],
    isHidden: true
  },
    {
    title: "Revenue Reverse Engineering",
    description: "Reverse Engineer Your Earning Goals based on your Business Model",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1738361078/revenue-earning-planner_qebfac.png",
    url: "https://chatgpt.com/g/g-679c893391008191a6821f48af50d442-revenue-reverse-engineering",
    rating: 0,
    reviews: 0,
    categories: ["Marketing Strategy", "Marketing Campaigns", "Foundational"],
    tags: ["revenue", "business model", "earning goals", "marketing strategy"],
    isHidden: false
  },
    {
    title: "Common Mistakes Video Script Generator",
    description: "Generate video scripts highlighting common mistakes and solutions.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732661713/common-mistakes_rclviw.jpg",
    url: "https://chatgpt.com/g/g-dVvaqU0jb-common-mistakes-video-script-generator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy"],
    tags: ["video script", "common mistakes", "content strategy"],
    isHidden: false
  },
    {
    title: "Lead Magnet Strategist",
    description: "Develop and plan the most effective lead magnets for lead generation",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1737348032/lead-magnet-strategist_ociwgo.jpg",
    url: "https://chatgpt.com/g/g-678d9f6fa11881919187e52f6072975b-lead-magnet-strategist",
    rating: 0,
    reviews: 0,
    categories: ["Digital Brain", "Marketing Strategy", "Foundational"],
    tags: ["lead magnet", "lead generation", "marketing strategy", "digital brain"],
    isHidden: false
  },
  {
    title: "Micro Offer Deal Creator",
    description: "Turn your passions and skills into income streams using a simple four-step process",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1734327267/DALL_E_2024-12-16_15.34.06_-_A_sleek_futuristic_neon_logo_for_Micro_Offer_Deal_Creator_._The_design_features_a_glowing_dollar_sign_intertwined_with_a_hypnotic_spiral_as_the_main_pz0kqk.webp",
    url: "https://chatgpt.com/g/g-cOF63YLoW-micro-offer-idea-creator-v2",
    rating: 0,
    reviews: 0,
    categories: ["Digital Brain", "Marketing Strategy", "Foundational"],
    tags: ["micro offer", "income streams", "marketing strategy", "digital brain"],
    isHidden: false
  },
  {
    title: "T.E.A.C.H. Course Creator",
    description: "Create a unqiue & profoundly transformational course in 10 minutes",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1741909285/teach-course-creator_ojttc3.png",
    url: "https://chatgpt.com/g/g-67cfb0b3a538819188f3a2a71d1b76ad-course-creator-gizmo-v2",
    rating: 0,
    reviews: 0,
    categories: ["Digital Brain", "Marketing Strategy", "Foundational"],
    tags: ["course creator", "teaching", "digital brain", "marketing strategy"],
    isHidden: false
  },
    {
    title: "Pillar Content Creator",
    description: "Transform core themes into powerful content strategies.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414938/pillar-content-creator_lxklxg.jpg",
    url: "https://chatgpt.com/g/g-AxrDpONU5-pillar-content-creator-gpt",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "SEO", "Foundational"],
    tags: ["pillar content", "content strategy", "seo", "foundational"],
    isHidden: false
  },
   {
    title: "30-Day Social Media Content Calendar",
    description: "Create a custom 30-Day Social Media Content Calendar",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1737090886/social-media-content-calendar-icon_zethms.png",
    url: "https://chatgpt.com/g/g-67899d5fca808191b0f462cb23463d41-social-media-content-calendar",
    rating: 0,
    reviews: 0,
    categories: ["SEO", "Content Strategy"],
    tags: ["social media", "content calendar", "seo", "content strategy"],
    isHidden: false
  },
  {
    title: "LinkedIn Content Creator",
    description: "Create engaging and professional LinkedIn content that drives engagement and builds your personal brand.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1747957269/linkedin-content-creator_jd4y8n.png",
    url: "https://chatgpt.com/g/g-682fac12222081919ae39b72c54cbe13-li-content-creator",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Social Media"],
    tags: ["linkedin", "content", "social media", "personal brand"],
    isHidden: false,
  },
  {
    title: "5-Day Story-Post Strategy Generator",
    description: "Create five high-converting Facebook story-style posts, demonstrating how to blend personal pain points, insight, and transformation into emotionally resonant content that drives comments or clicks to coaching offers.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1750978357/a-vibrant-neon-logo-featuring-the-text-5_FSLPydzlS7GJDVWTK1YyMg_Ghz8-ijXTC2A-VAQo_QcSw_dinpgh.png",
    url: "https://chatgpt.com/g/g-685dcde1e458819187a9e2c16709f70a-5-day-story-post-strategy-generator",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Social Media", "Marketing Strategy"],
    tags: ["facebook", "story posts", "content strategy", "social media", "marketing", "coaching"],
    isHidden: false
  },
  {
    title: "IG Carousel Creator",
    description: "Transforms long-form writing into engaging carousel posts with tailored strategies, clear slide maps, and guidance to grow your audience with swipe-worthy, high-value content.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1752444499/IG_carousel_bu6n6f.png",
    url: " https://chatgpt.com/g/g-68705113fb1481919b12d3631f9f6cbf-carousel-creator",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Social Media", "Marketing Strategy"],
    tags: ["instagram", "story posts", "content strategy", "social media", "marketing", "coaching"],
    isHidden: false
  },
 
        {
    title: "The Archetype Creator",
    description: "Create Unique Archetype Frameworks based on your Target Market's problems",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1737954336/Archetype-creator_b5xgll.jpg",
    url: "https://chatgpt.com/g/g-67975f3b80a88191a898d8477145ec49-archetype-creator",
    rating: 0,
    reviews: 0,
    categories: ["Offer Creation", "Marketing Campaigns", "Foundational", "Branding"],
    tags: ["archetype", "target market", "offer creation", "branding"],
    isHidden: false
  },
  {
    title: "The Problem-Solution Framework Creator",
    description: "guides coaches through a structured, clear interactive process: identifying core problems, dysfunctional and solution traits, mapping Venn diagram archetypes, and defining transformational pathways interactively.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1752443790/a-digital-illustration-of-a-sleek-neon-l_9eeLBsq8SkahPOB79L2_uA_9TXiwkT7RqG7YKH5D4FFhA_e5wuj1.png",
    url: "https://chatgpt.com/g/g-67975f3b80a88191a898d8477145ec49-archetype-creator",
    rating: 0,
    reviews: 0,
    categories: ["Offer Creation", "Marketing Campaigns", "Foundational", "Branding"],
    tags: ["archetype", "target market", "offer creation", "branding"],
    isHidden: false
  },
    {
    title: "Market Research Rocket",
    description: "Develop detailed customer profiles with comprehensive research.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414946/market-research-rocket_rgfmvw.webp",
    url: "https://chatgpt.com/g/g-jxZS0QF6s-market-research-rocket",
    rating: 0,
    reviews: 0,
    categories: ["Foundational", "Marketing Strategy"],
    tags: ["market research", "customer profiles", "foundational", "marketing strategy"],
    isHidden: false
  },
  {
    title: "Brand 'Positioning' Coach",
    description: "Develop distinct brand identities with strategic positioning.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414939/Brand-positioning-coach_bzl2wu.jpg",
    url: "https://chatgpt.com/g/g-ZsJ2NdwVP-brand-positioning-coach",
    rating: 0,
    reviews: 0,
    categories: ["Branding", "Foundational"],
    tags: ["brand positioning", "brand identity", "branding", "foundational"],
    isHidden: false
  },
  {
    title: "Brand Voice Designer",
    description: "Design a compelling brand identity with consistent voice and tone.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414947/brand-voice_lj6bfu.webp",
    url: "https://chatgpt.com/g/g-esKPJFB0x-brand-voice-designer",
    rating: 0,
    reviews: 0,
    categories: ["Branding", "Content Strategy", "Foundational"],
    tags: ["brand voice", "brand identity", "branding", "content strategy"],
    isHidden: false
  },
  {
    title: "Personal Writing Fingerprint Creator",
    description: "Analyze writing samples to identify unique patterns and characteristics.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414945/DALL_E_2024-08-29_19.06.08_-_A_neon_mascot_logo_for_AI_Ghostwriter._The_design_features_a_playful_glowing_ghost_character_with_bright_animated_eyes_holding_a_pen_or_quill_in_sehhca.webp",
    url: "https://chatgpt.com/g/g-6PU0Hxcvi-personal-writing-fingerprint-creator",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Branding", "Foundational"],
    tags: ["writing fingerprint", "writing analysis", "content strategy", "branding"],
    isHidden: false
  },
  {
    title: "Key Marketing Message Writer",
    description: "Design high-impact marketing messages that resonate and compel action.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414936/marketing-message-writer_fh68h0.jpg",
    url: "https://chatgpt.com/g/g-6muNTz0ly-key-marketing-message-writer",
    rating: 0,
    reviews: 0,
    categories: ["Marketing Strategy", "Copywriting", "Foundational", "Branding"],
    tags: ["marketing messages", "copywriting", "marketing strategy", "branding"],
    isHidden: false
},
{
  title: "Advanced Copywriting",
  description: "Design high-impact marketing messages that resonate and compel action.",
  imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1743282028/a-futuristic-sleek-modern-app-icon-with-_iI3x1lmFQf2rNqW8_LfqRg__eLHZ-QjShqmT34txZnhKw_n97tk1.png",
  url: "https://chatgpt.com/g/g-67c92f7f2588819194119297330613aa-advanced-copywriting-strategist",
  rating: 0,
  reviews: 0,
  categories: ["Marketing Strategy", "Copywriting", "Foundational", "Branding"],
  tags: ["advanced copywriting", "marketing messages", "copywriting", "marketing strategy"],
  isHidden: false
},
{
  title: "Mechanism Focused Copywriting",
  description: "create conversion-optimized marketing assets entirely around a unique mechanism",
  imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1743243569/a-futuristic-neon-logo-set-against-a-glo_2ZUUPyL8SeSif8u_YRf5vQ_XOt8KpP5QeWkiwzYt316ww_iw6a9j.png",
  url: "https://chatgpt.com/g/g-67e7c3092bc48191b9eadb609fc58378-mechanism-focused-copywriting",
  rating: 0,
  reviews: 0,
  categories: ["Marketing Strategy", "Copywriting", "Foundational", "Branding"],
  tags: ["mechanism copywriting", "conversion", "marketing assets", "copywriting"],
  isHidden: false
},
  // SEO & Content Tools
  {
    title: "Copywriting Template Maker",
    description: "Create a template in seconds from any ad, sales page or offer content",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732666491/DALL_E_2024-11-27_09.25.39_-_A_neon_logo_featuring_the_text_Copywriting_Template_Maker_in_vibrant_neon_gradient_colors_transitioning_from_pink_to_orange._A_glowing_pen_emitting_kedqwi.webp",
    url: "https://chatgpt.com/g/g-ikZOgYX7B-copywriting-template-maker",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Marketing Campaigns"],
    isHidden: false
  },
    {
    title: "SEO Authority Lists Post Creator",
    description: "Create high-impact, SEO-targeted authority list posts.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414940/seo-article-creator-lists_gydqzd.jpg",
    url: "https://chatgpt.com/g/g-ju9XAQkOr-seo-authority-lists-post-creator",
    rating: 0,
    reviews: 0,
    categories: ["SEO", "Content Strategy"],
    isHidden: false
  },
  {
    title: "SEO Authority 'Truth Revelation' Post Creator",
    description: "Craft SEO articles that debunk myths and offer actionable insights.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1734346949/a-stylized-esports-logo-featuring-a-fier_pbK2_me1QD2EukrXLlMalQ_lBuHuIruSUWNgePoe6eyUA_csoddv.png",
    url: "https://chatgpt.com/g/g-YaxcfOU2u-seo-authority-truth-revelation-post-creator",
    rating: 0,
    reviews: 0,
    categories: ["SEO", "Content Strategy"],
    isHidden: false
  },
  {
    title: "SEO Authority 'How To' Post Creator",
    description: "Create high-ranking \"How To\" posts that target specific audience needs.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414941/seo-article-creator-how-to_lvyyyo.jpg",
    url: "https://chatgpt.com/g/g-E6PyEByod-seo-authority-how-to-post-creator",
    rating: 0,
    reviews: 0,
    categories: ["SEO", "Content Strategy"],
    isHidden: false
  },
  {
    title: "SEO Foundations 'What it Is' Post Creator",
    description: "Create engaging \"What It Is\" posts that target low-competition queries.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414941/seo-article-creator-foundations_zzps9d.jpg",
    url: "https://chatgpt.com/g/g-hLNXrTiqk-seo-foundations-what-it-is-post-creator",
    rating: 0,
    reviews: 0,
    categories: ["SEO", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Press Release Creator",
    description: "Create Compelling Press Releases that get you noticed.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1734729093/Press-Release-Creator_ogvxuh.webp",
    url: "https://chatgpt.com/g/g-676508c30e408191a436dcf9234920c9-press-release-creator-gpt",
    rating: 0,
    reviews: 0,
    categories: ["Press Releases", "Content Strategy"],
    isHidden: false
  },
  // Video Tools
  {
    title: "VSL Creator",
    description: "Create Video Sales Letters that convert leads into customers.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/c_thumb,w_200,g_face/v1734572673/DALL_E_2024-12-19_11.44.14_-_2._An_artistic_brushstroke_neon_logo_for_VSL_Creator_using_a_gradient_color_transition_from_purple_to_pink._The_text_features_a_glowing_shadow_and_sjv9fu.webp",
    url: "https://chatgpt.com/g/g-676378a7014c8191ad0d5e3c89532092-vsl-creator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Zero-to-Hero Script Generator",
    description: "Create personalized video scripts showcasing transformational business journeys.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732660320/zero-2-hero_tbakcg.jpg",
    url: "https://chatgpt.com/g/g-LYVQSGhMA-zero-to-hero-script-generator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy"],
    isHidden: false
  },
  {
    title: "One-Big-Problem Video Script Generator",
    description: "Create compelling video scripts that address key audience problems.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732660320/one-big-problem-vid_zfsc0u.jpg",
    url: "https://chatgpt.com/g/g-02zK4uOoD-one-big-problem-video-script-generator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy"],
    isHidden: false
  },
  {
    title: "10x Video Content Planner",
    description: "Create 10x personalized videos in a unified strategy using storytelling and psychology.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732667858/DALL_E_2024-11-27_10.37.15_-_A_neon_logo_featuring_the_text_10x_Video_Content_Planner_in_bold_retro_neon_colors_of_pink_and_teal._The_design_includes_a_glowing_vintage_camcorder_fe0gfz.webp",
    url: "https://chatgpt.com/g/g-BCGX2UJ99-10x-video-content-planner-v2",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy", "Marketing Strategy"],
    isHidden: false
  },
  {
    title: "Viral Tiktok Reel Video Creator",
    description: "Create engaging TikTok content that drives viral success.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414945/Viral_Video_Designer_o82nst.jpg",
    url: "https://chatgpt.com/g/g-gtGLdkND1-viral-titktok-reel-video-creator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Marketing Campaigns"],
    isHidden: false
  },
  {
    title: "Youtube Video Title Creator",
    description: "Generate optimized and engaging YouTube video titles.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/c_thumb,w_200,g_face/v1734568955/DALL_E_2024-12-19_10.36.56_-_A_futuristic_neon_logo_featuring_gradient_text_transitioning_from_blue_to_purple_that_reads_YouTube_Title_Creator._The_design_includes_a_glowing_whi_bvzmro.webp",
    url: "https://chatgpt.com/g/g-K2beMR1t5-youtube-video-title-creator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "SEO"],
    isHidden: true
  },
  {
    title: "Youtube Video Description Creator",
    description: "Generate optimized and engaging YouTube video Descriptions.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/c_thumb,w_200,g_face/v1734570427/Youtube_Description_Creator_qzvn3d.webp",
    url: "https://chatgpt.com/g/g-gvtTF1OWG-youtube-video-description-creator",
    rating: 0,
    reviews: 0,
    categories: ["Video", "SEO"],
    isHidden: true
  },
  {
    title: "Educational Video Content Analyst",
    description: "Break down educational videos with precision for enhanced content effectiveness.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414934/Educational-content-analyser_ito3vw.jpg",
    url: "https://chatgpt.com/g/g-PIYxuxD6B-educational-video-content-analyst",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Content Strategy"],
    isHidden: false
  },

  // Sales & Ads Tools
  {
    title: "PITCHRR - FB Ad Creator",
    description: "Create high-converting Facebook ads using PITCHRR principles.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414939/fb-ad-creator_kqqrct.jpg",
    url: "https://chatgpt.com/g/g-5xJhOGb7P-pitchrr-fb-ad-creator",
    rating: 0,
    reviews: 0,
    categories: ["Ads", "Marketing Strategy"],
    isHidden: true
  },
  {
    title: "Hook-Story-Sell Script Builder GPT",
    description: "Create compelling Hook, Story, Segue, Sell video scripts that boost engagement.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/c_thumb,w_200,g_face/v1734567854/hook-story-sell-paid-ads_gfmrew.jpg",
    url: "https://chatgpt.com/g/g-0stBOiyTV-ysss-script-builder-gpt",
    rating: 0,
    reviews: 0,
    categories: ["Video", "Ads", "Marketing Campaigns"],
    isHidden: false
  },
  {
    title: "The Ad Copywriter",
    description: "Create high-impact ad campaigns by crafting compelling copy for maximum conversions.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414942/Paid-ads-writer_yx8pnx.jpg",
    url: "https://chatgpt.com/g/g-K6BxLWloO-ic-the-ad-copywriter",
    rating: 0,
    reviews: 0,
    categories: ["Marketing Campaigns", "Ads"],
    isHidden: false
  },

  // Email Tools
  {
    title: "Free Offer Promotional Email Creator-v2",
    description: "Create persuasive promotional emails for free training events.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414939/free-offer-promo-email-writer_yojltl.webp",
    url: "https://chatgpt.com/g/g-7sRH53LHP-free-offer-promotional-email-creator-v2",
    rating: 0,
    reviews: 0,
    categories: ["Emails", "Marketing Campaigns"],
    isHidden: false
  },
  {
    title: "Newsletter Email Creator",
    description: "Create compelling newsletters that educate, engage, and convert.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414938/monthly-newsletter-email-writer_tziavo.webp",
    url: "https://chatgpt.com/g/g-5fntF2WgO-newsletter-email-creator",
    rating: 0,
    reviews: 0,
    categories: ["Emails", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Low Ticket Sales Email Creator",
    description: "Create effective email campaigns to drive conversions and boost engagement.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414941/low-ticket-offer-promo-email-writer_ceyl7c.jpg",
    url: "https://chatgpt.com/g/g-67c112bb13008191945cd619856570cf-low-ticket-sales-email-creator",
    rating: 0,
    reviews: 0,
    categories: ["Emails", "Marketing Campaigns"],
    isHidden: false
  },
  {
    title: "High Ticket Sales Email Creator",
    description: "Craft high-impact email sequences for high-ticket items.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414938/high-ticket-offer-promo-email-writer_jvkyiz.jpg",
    url: "https://chatgpt.com/g/g-6BElxw0QZ-ic-high-ticket-sales-email-creator",
    rating: 0,
    reviews: 0,
    categories: ["Emails", "Marketing Campaigns"],
    isHidden: false
  },

  // Webinar Tools
  {
    title: "The Presentation Creator v2",
    description: "Create impactful presentations using a structured slide deck format.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/c_thumb,w_200,g_face/v1734567854/presentation-creator_bkvkk0.jpg",
    url: "https://chatgpt.com/g/g-5pfhGGapG-presentation-creator-v2",
    rating: 0,
    reviews: 0,
    categories: ["Webinars", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Webinar Sales Script",
    description: "Create engaging sales scripts to add to the end of webinars",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414946/webinar-sales-script_kxqzjp.jpg",
    url: "https://chatgpt.com/g/g-vUcuSEi87-webinar-sales-script-gpt-v1",
    rating: 0,
    reviews: 0,
    categories: ["Webinars", "Marketing Campaigns"],
    isHidden: true
  },

  // Books
  {
    "title": "Best-Selling Book Outline Creator",
    "description": "Craft high-impact, market-driven outlines for non-fiction books that captivate readers and drive sales.",
    "imageUrl": "https://res.cloudinary.com/dhxriuzu5/image/upload/v1740718143/DALL_E_2025-02-28_09.58.38_-_A_neon_logo_featuring_an_open_book_with_a_glowing_gradient_effect_smoothly_transitioning_between_blue_purple_and_pink._The_text_Best_Selling_Book_ywfxms.webp",
    "url": "https://chatgpt.com/g/g-67c0fc97c8e081918f74f728cf16613f-best-selling-book-outline-creator",
    "rating": 0,
    "reviews": 0,
    "categories": ["Book Writing", "Publishing Strategy"],
    "isHidden": false
  },
  {
    title: "Non-Fiction Book Introduction Specialist",
    description: "Craft compelling introductions for non-fiction books.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1734567854/Non-fiction-intro-specialist_jrkz4a.jpg",
    url: "https://chatgpt.com/g/g-JyoRgJZk4-non-fiction-book-introduction-specialist",
    rating: 0,
    reviews: 0,
    categories: ["Content Strategy", "Lead Magnet"],
    isHidden: false
  },

  // Images
  {
    title: "Infographic Reverse Engineer Expert",
    description: "Analyze and adapt infographic frameworks for any business or topic.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414944/infographic-reverse-engineer_ckebhz.webp",
    url: "https://chatgpt.com/g/g-rI3pRHoEK-infographic-reverse-engineer-expert",
    rating: 0,
    reviews: 0,
    categories: ["Images", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Captivating Comic Book Image Artist-V2",
    description: "Create stunning comic book and cartoon-style images.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1734496696/DALL_E_2024-07-12_20.33.34_-_Create_a_gradient_neon_mascot_logo_for_Captivating_Comic_Book_Image_Artist._The_design_should_include_an_illustrated_character_that_represents_a_com_muu1ox.webp",
    url: "https://chatgpt.com/g/g-kbLqrlQXU-captivating-comic-book-image-artist",
    rating: 0,
    reviews: 0,
    categories: ["Images", "Content Strategy"],
    isHidden: false
  },
  {
    title: "Icon Designer",
    description: "Design clean and visually striking icons with bold vector style.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414937/icon-designer_mvpgwp.jpg",
    url: "https://chatgpt.com/g/g-K2beMR1t5-icon-designer-gpt",
    rating: 0,
    reviews: 0,
    categories: ["Images"],
    isHidden: false
  },
  {
    title: "Social Media Image Creator V4",
    description: "Create captivating social media images with powerful messaging.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414934/social-media-image-creator_nrwmc6.jpg",
    url: "https://chatgpt.com/g/g-R3qT42TJ5-social-media-image-creator-v4",
    rating: 0,
    reviews: 0,
    categories: ["Images"],
    isHidden: false
  },
  {
    title: "Prompt Tag Designer",
    description: "Design effective and structured prompts that enhance clarity and quality.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732659254/Prompt-tag-designer_paojiu.jpg",
    url: "https://chatgpt.com/g/g-tsxC2IPer-prompt-tag-designer",
    rating: 0,
    reviews: 0,
    categories: ["Digital Brain", "Content Strategy"],
    isHidden: true
  },
  {
    title: "Custom Chatbot Knowledge File Creator",
    description: "Create comprehensive FAQ knowledge files for seamless customer service.",
    imageUrl: "https://hypnolab.ai/wp-content/plugins/hypnolab-ai-tools/images/website-content-creator.webp",
    url: "https://chatgpt.com/g/g-ZHcTHJthN-custom-chatbot-knowledge-file-creator",
    rating: 0,
    reviews: 0,
    categories: ["Digital Brain", "Website Content"],
    isHidden: true
  },
  {
    title: "Neon Logo Generator",
    description: "Create visually stunning neon logos with AI assistance.",
    imageUrl: "https://hypnolab.ai/wp-content/plugins/hypnolab-ai-tools/images/logo-creator.webp",
    url: "https://chatgpt.com/g/g-teROc2S3H-neon-logo-generator-gpt-v2",
    rating: 0,
    reviews: 0,
    categories: ["Images", "Branding"],
    isHidden: false
  },
    {
    title: "Ultimate GPT Builder Bot - v2",
    description: "Create custom GPTs effortlessly with AI-driven insights and connections.",
    imageUrl: "https://res.cloudinary.com/dhxriuzu5/image/upload/v1732414946/DALL_E_2024-07-09_21.12.45_-_A_neon_logo_with_a_multicolored_design_featuring_smooth_color_transitions_showcasing_the_text_The_Ultimate_GPT_Builder_Bot_in_a_gradient_neon_style_v8vriq.webp",
    url: "https://chatgpt.com/g/g-xBYEiQi0C-the-ultimate-gpt-builder-bot-v2",
    rating: 0,
    reviews: 0,
    categories: ["General", "Custom GPT"],
    isHidden: false
  }
];